import GestureRootViewAndFont from "@provider/gesture-and-font";

import * as React from "react";

import { AppDataProvider } from "./app-data";
import { AuthStateProvider } from "./context-auth";
import { Dripsy } from "./dripsy";
import { SafeArea } from "./safe-area";
import Toast from "./toast";
import QueryClientProvider from "@provider/query-client";
import AsyncBoundary from "@components/async-boundary";
import { StoryBlokProvider } from "./storyblok-provider";
import { AssistantProvider } from "@features/assistant/assistant-provider";

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <GestureRootViewAndFont>
        <Dripsy>
          <QueryClientProvider>
            <SafeArea>
              <AsyncBoundary>
                <StoryBlokProvider>
                  <AuthStateProvider>
                    <AppDataProvider>
                      <AssistantProvider>
                        {children}
                        <Toast />
                      </AssistantProvider>
                    </AppDataProvider>
                  </AuthStateProvider>
                </StoryBlokProvider>
              </AsyncBoundary>
            </SafeArea>
          </QueryClientProvider>
        </Dripsy>
      </GestureRootViewAndFont>
    </>
  );
}
